function Desktop({
  children
}) {
  return children;
}

export { Desktop };
